import React, { useEffect, useState, useRef } from "react";
import {
  Route,
  Redirect,
} from "react-router-dom";

import {useAuth} from "../../lib/auth/useAuth";


// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
export default function PrivateRoute({ children, render, ...rest }) {
  let auth = useAuth();
  let [loggedIn, setLoggedIn] = useState(false)
  let [loaded, setLoaded] = useState(false)
  const isMountedRef = useRef(true);
  
  useEffect(() => {
    setLoaded(false);
    async function isLoggedIn() {
      const result = await auth.isLoggedIn();
      if (isMountedRef.current) {
        setLoggedIn(result);
        setLoaded(true);
      }
    }
    isLoggedIn()
    
    return () => {
      isMountedRef.current = false;
    };
  }, [auth])

  return (
    <div>
      {loggedIn ?
        <Route
          {...rest}
          render={render || children}
        /> : ''
      }
      {loaded && !loggedIn ? <Redirect to={"/login"}/> : ''}
    </div>
  );
}
